import { bookableOptionValueZodSchema } from "@@/shared/acquire/resource-reference-options/bookable-option-value-zod-schemas";
import { resourceReservationIdZodSchema } from "@@/shared/acquire/resources/resource-reservation-id";
import { userIdZodSchema } from "@@/shared/users/user-id";
import { generateWordSlug } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type {
    _OrderEventBaseFactoryParams} from "./_order-base.event";
import {
    _orderEventBaseFactory,
    _orderEventBaseZodObject,
} from "./_order-base.event";

const orderEventBookableReservationUpdatedZodSchema =
    _orderEventBaseZodObject.merge(
        z.object({
            type: z.literal("BOOKABLE_TABLE_RESERVATION_UPDATED"),
            reservationId: resourceReservationIdZodSchema,
            changedBy: userIdZodSchema,
            old: z.array(bookableOptionValueZodSchema),
            new: z.array(bookableOptionValueZodSchema),
        }),
    );
type OrderBookableReservationUpdatedEvent = z.infer<
    typeof orderEventBookableReservationUpdatedZodSchema
>;
// Factory params
type FactoryParams = _OrderEventBaseFactoryParams &
    Except<
        OrderBookableReservationUpdatedEvent,
        "type" | "_id" | "_type" | "_createdAt" | "signature"
    >;

type Params = Except<FactoryParams, "signature">;
const orderEventBookableReservationUpdatedFactory = (
    params: Params,
): OrderBookableReservationUpdatedEvent => ({
    ..._orderEventBaseFactory({
        ...params,
        signature: [
            params.orderId,
            "BOOKABLE_TABLE_RESERVATION_UPDATED",
            [generateWordSlug()],
        ],
    }),

    type: "BOOKABLE_TABLE_RESERVATION_UPDATED",
    changedBy: params.changedBy,
    old: params.old,
    new: params.new,
    reservationId: params.reservationId,
});

export {
    orderEventBookableReservationUpdatedFactory,
    orderEventBookableReservationUpdatedZodSchema,
};
export type { OrderBookableReservationUpdatedEvent };
